import { createApi } from '../common/API'
import useAsync from '../../hooks/async'
import { useCallback } from 'react';


export const fetchPack = createApi('/pack/query', {noThrow: false, notify: true});

export const usePack = (id) => {
  const execute = useCallback(() => {
    if (/^\d+$/.test(id)) {
      return fetchPack({id})
    }
    return fetchPack({url:id})
  }, [id])
  const data = useAsync(execute, true)
  return {...data}
}


export const fetchLoops = createApi('/loop/queryPresets');


export const useLoops = ({packId, page, pageSize}) => {
  const call = useCallback(() => fetchLoops({packId, page, pageSize}), [packId, page, pageSize])
  const data = useAsync(call, true)
  return {...data}
}

export const fetchPresets = createApi('/loop/queryPresets', {expandData: false});
export const fetchMyLoops = createApi('/loop/queryMyLoops', {expandData: false});

export const usePresets = () => {
  const data = useAsync(fetchPresets, false)
  return {...data, pending: data.status === 'pending'}
}

export const useMyLoops = () => {
  const data = useAsync(fetchMyLoops, false)
  return {...data, pending: data.status === 'pending'}
}